"use client";

import type {Params} from "next/dist/server/request/params";
import type {Breadcrumb} from "../../types";
import {addBreadcrumb} from "../../lib/breadcrumbs";

type Props = Breadcrumb & 
{
    params?: Params;
    children?: React.ReactNode;
};

export default function BreadcrumbProvider({children, params, ...breadcrumb}: Props)
{
    addBreadcrumb(breadcrumb, params);

    return children;
}
